import * as API from '@/api/device';
import countDown from '@/libs/countdown';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      vpnStatus: 0,
      webuiInfo: null,
      sshInfo: null,
      checkLoading: true,
      countDownTimer: null,
      vpnType: null,
      destoryLoading: false,
      pollingCheckTimer: null,

      // 等待一分钟自动关闭
      waitToCloseTime: 1 * 60 * 1000,
      waitToCloseTimer: null,

      // vpn error
      // 0：空闲；1：VPN连接成功；2-VPN连接失败；3-不支持VPN功能；10-执行中；11-设备禁用；12-设备离线；13-执行超时；
      VPNError: {
        2: this.$t('device_vpn_connect_failed'),
        3: this.$t('device_vpn_not_support'),
        11: this.$t('device_vpn_connect_device_disable'),
        12: this.$t('device_vpn_connect_device_offline'),
        13: this.$t('device_vpn_connect_executing_timeout'),
      },
      // VPN轮询
      VPNPollingTimer: null,
      VPNPollingTime: 2 * 1000,
      VPNHasStart: 1,
    };
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
  },
  watch: {
    visible(val) {
      if (!val) {
        this.clearCountDown();
        this.stopPollingVPNStatus();
        this.webuiInfo = null;
        this.sshInfo = null;
        this.checkLoading = true;
        this.vpnType = null;
      }
    },
  },

  beforeDestroy() {
    this.clearCountDown();
    this.stopWaitToCloseTimer();
    this.stopPollingVPNStatus();
  },
  created() {
    this.webuiInfo = null;
    this.sshInfo = null;
    this.checkLoading = true;
  },

  methods: {
    // 初始检查VPN连接状态
    checkVPNFisrt() {
      this.checkLoading = true;
      // 调用一次status/all
      if (this.deviceStatusFn && typeof this.deviceStatusFn === 'function') {
        this.deviceStatusFn()
          .then(_res => {
            // device状态中是否已经有webui信息
            if (this.vpnType === 'ssh') {
              if (this.deviceStatus && this.deviceStatus.ssh && this.deviceStatus.ssh.ssh) {
                this.sshInfo = this.deviceStatus.ssh.ssh;

                // 重新启动一下
                this.restartVPN();

                // 启用倒计时
                this.$nextTick(() => {
                  this.runCountdown();
                });

                this.checkLoading = false;
              }
            } else {
              if (this.deviceStatus && this.deviceStatus.webui && this.deviceStatus.webui.webUi) {
                this.webuiInfo = this.deviceStatus.webui.webUi;

                // 重新启动一下
                this.restartVPN();

                // 启用倒计时
                this.$nextTick(() => {
                  this.runCountdown();
                });
                this.checkLoading = false;
              }
            }
          })
          .finally(() => {
            this.checkLoading = false;
          });
      }
    },

    // 查询设备VPN连接状态
    checkVPNStatus() {
      API.DeviceVpnStatus({ devId: this.deviceInfo.devId })
        .then(res => {
          this.vpnStatusHandler(res);
        })
        .catch(_err => {
          this.vpnCallback(this.$t('com_network_error'));
          this.formLoading = false;
        });
    },

    PollingVPNStatus() {
      this.stopPollingVPNStatus();

      // VPN启动/关闭中，轮询状态
      const self = this;
      this.VPNPollingTimer = setTimeout(function() {
        self.checkVPNStatus();
      }, this.VPNPollingTime);
    },

    // 停止VPN轮询
    stopPollingVPNStatus() {
      if (this.VPNPollingTimer) {
        clearTimeout(this.VPNPollingTimer);
      }
    },

    // VPN状态处理
    vpnStatusHandler(res) {
      // 设备vpn执行状态，0：空闲；1：VPN连接成功；2-VPN连接失败；3-不支持VPN功能；10-执行中；11-设备禁用；12-设备离线；13-执行超时；
      if (res.code === 0) {
        const status = res.data;

        if (status === 0) {
          this.VPNHasStart = 2;
          // 启动VPN
          this.startVPN(this.deviceInfo.devId);
        } else if (status === 10) {
          this.PollingVPNStatus();
        } else if (status === 1) {
          // 停止轮询
          this.stopPollingVPNStatus();

          if (this.vpnType === 'ssh') {
            this.createSSHLink();
          } else {
            // 调用call-->查询webUI
            this.createWebuiLink();
          }
        } else {
          if (this.VPNHasStart === 2) {
            // 其他算报错
            this.vpnCallback(
              this.VPNError[status]
                ? this.VPNError[status]
                : this.$t('device_vpn_error', { status })
            );
          } else {
            this.VPNHasStart = 2;
            // 启动VPN
            this.startVPN(this.deviceInfo.devId);

            // 继续polling
            this.PollingVPNStatus();
          }
        }
      } else {
        // 报错
        this.vpnCallback(res.message);
        this.formLoading = false;
      }
    },

    // VPN接口相关回调
    vpnCallback(_message) {},

    // 启动VPN
    startVPN() {
      API.DeviceVpnStart({ devId: this.deviceInfo.devId })
        .then(res => {
          if (res.code === 0) {
            this.PollingVPNStatus();
          } else {
            this.vpnCallback(res.message);
          }
        })
        .catch(_err => {
          this.vpnCallback(this.$t('com_network_error'));
          this.formLoading = false;
        });
    },

    // 重新启动VPN
    restartVPN() {
      API.DeviceVpnReStart({ devId: this.deviceInfo.devId }).then(_res => {
        console.log('restart', _res);
      });
    },

    checkWebUICreated() {
      const params = {
        devId: this.deviceInfo.devId,
      };
      // 判断WEBUI连接是否连接 * 0-未连接， * 1-已连接， * 99-不支持功能
      API.DeviceWebUICreated(params)
        .then(res => {
          if (res.code === 0 && res.data) {
            const status = res.data.status;
            if (status === 1) {
              if (res.data.webUi) {
                this.webuiInfo = res.data.webUi;
              } else {
                this.webuiInfo = null;
              }
              // 启用倒计时
              this.$nextTick(() => {
                this.runCountdown();
              });

              this.checkLoading = false;
            }
          } else {
            this.vpnCallback(res.message);
          }
        })
        .finally(() => {
          this.checkLoading = false;
        });
    },

    // 创建WEBUI
    createWebuiLink(init) {
      const params = {
        devId: this.deviceInfo.devId,
        period: init ? 0 : this.form.period || 30,
      };

      API.DeviceWebUIConnect(params)
        .then(res => {
          if (res.code === 38904 && !init) {
            // 返回值为38904表示VPN设备被断开请前端再次重连【001-启动VPN连接】
            this.startVPN(this.deviceInfo.devId);
            return;
          }

          if (res.code === 0) {
            this.checkLoading = false;

            this.webuiInfo = res.data;
            this.formLoading = false;
            this.formError = '';

            // 查询状态
            this.checkDeviceStatus();

            // 启用倒计时
            this.$nextTick(() => {
              this.runCountdown();
            });
          } else {
            this.formError = res.message;
          }
        })
        .finally(() => {
          this.checkLoading = false;
          this.formLoading = false;
        });
    },

    // 创建SSH
    checkSSHCreated() {
      const params = {
        devId: this.deviceInfo.devId,
      };
      // 判断SSH连接是否连接 * 0-未连接， * 1-已连接， * 99-不支持功能
      API.DeviceSshCreated(params)
        .then(res => {
          if (res.code === 0 && res.data) {
            const status = res.data.status;
            if (status === 1) {
              if (res.data.ssh) {
                this.sshInfo = res.data.ssh;
              } else {
                this.sshInfo = null;
              }

              // 启用倒计时
              this.$nextTick(() => {
                this.runCountdown();
              });
            }
          } else {
            this.vpnCallback(res.message);
          }
        })
        .finally(() => {
          this.checkLoading = false;
        });
    },

    // 跳转到SSH 验证页面
    createSSHLink(init) {
      const params = {
        devId: this.deviceInfo.devId,
        period: init ? 0 : this.form.period || 30,
      };

      API.DeviceSshConnect(params)
        .then(res => {
          if (res.code === 38904 && !init) {
            // 返回值为38904表示VPN设备被断开请前端再次重连【001-启动VPN连接】
            this.startVPN(this.deviceInfo.devId);
            return;
          }

          if (res.code === 0) {
            this.checkLoading = false;

            this.sshInfo = res.data;
            this.formLoading = false;
            this.formError = '';

            // 查询状态
            this.checkDeviceStatus();

            // 启用倒计时
            this.$nextTick(() => {
              this.runCountdown();
            });
          } else {
            this.formError = res.message;
          }
        })
        .finally(() => {
          this.checkLoading = false;
          this.formLoading = false;
        });
    },

    // 销毁SSH
    destorySSHLink({ callback = () => {} }) {
      const params = {
        devId: this.deviceInfo.devId,
      };
      this.destoryLoading = true;
      API.DeviceSshDisconnect(params)
        .then(res => {
          if (res.code === 0) {
            callback && callback();
            this.sshInfo = null;
            this.clearCountDown();
            this.visible = false;

            this.checkDeviceStatus();
          }
        })
        .finally(() => {
          this.destoryLoading = false;
        });
    },

    // 销毁WEBUI
    destoryWEBUI({ callback = () => {} }) {
      const params = {
        devId: this.deviceInfo.devId,
      };
      this.destoryLoading = true;
      API.DeviceWebUIDisconnect(params)
        .then(res => {
          if (res.code === 0) {
            callback && callback();
            this.webuiInfo = null;
            this.clearCountDown();
            this.visible = false;

            this.checkDeviceStatus();
          }
        })
        .finally(() => {
          this.destoryLoading = false;
        });
    },

    // 1分钟后自动关闭弹窗，如果弹窗没有关闭的话
    autoCloseModal() {
      this.visible = false;
    },

    stopWaitToCloseTimer() {
      if (this.waitToCloseTimer) {
        clearTimeout(this.waitToCloseTimer);
      }
    },

    //倒计时
    runCountdown() {
      const self = this;
      // 倒计时
      this.waitToCloseTimer = setTimeout(function() {
        self.stopWaitToCloseTimer();
        self.visible = false;
      }, this.waitToCloseTime);

      if (this.$refs.expiredTime) {
        // 倒时计
        this.countDownTimer = countDown(this.$refs.expiredTime, {
          // restPeriod是分钟
          time: this.vpnType === 'ssh' ? this.sshInfo.restPeriod : this.webuiInfo.restPeriod,
          zeroShow: false,
          dateText: {
            day: ` ${this.$t('com_time_day')} `,
            hour: ` ${this.$t('com_time_hour')} `,
            minute: ` ${this.$t('com_time_minute')} `,
            second: ` ${this.$t('com_time_second')} `,
          },
          render: opts => {
            const date = opts.date;
            const dateText = opts.dateText;
            // console.log('data', opts);
            const html =
              (date.day ? `<b style="color:red;">${date.day}</b>${dateText.day}` : '') +
              (date.hour ? `<b style="color:red;">${date.hour}</b>${dateText.hour}` : '') +
              (date.minute ? `<b style="color:red;">${date.minute}</b>${dateText.minute}` : '') +
              (date.second ? `<b style="color:red;">${date.second}</b>${dateText.second}` : '');

            this.$refs.expiredTime.innerHTML = html;
          },
        });
      }
    },
    clearCountDown() {
      clearTimeout(this.countDownTimer);
    },

    // 回调查询状态
    checkDeviceStatus() {
      // 回调查询状态
      if (typeof this.deviceStatusFn === 'function') {
        this.deviceStatusFn();
      }
    },
  },
};
